module.exports = __webpack_public_path__ + "img/snow-leopard-title.6ebe939d.png";